"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreCollapsibleContainer = require("@legacy-vfuk/core-collapsible-container");

var _coreParagraph = _interopRequireDefault(require("@legacy-vfuk/core-paragraph"));

var _corePill = _interopRequireDefault(require("@legacy-vfuk/core-pill"));

var _coreSpacing = _interopRequireDefault(require("@legacy-vfuk/core-spacing"));

var Styled = _interopRequireWildcard(require("./styles/FilterSection.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FilterSection = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilterSection, _PureComponent);

  var _super = _createSuper(FilterSection);

  function FilterSection() {
    var _this;

    _classCallCheck(this, FilterSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isCollapsibleContainerOpen: true
    };

    _this.toggleCollapsibleContainer = function () {
      _this.setState({
        isCollapsibleContainerOpen: !_this.state.isCollapsibleContainerOpen
      });
    };

    _this.handleToggleCollapsibleContainer = function () {
      // If the collapsible container is not open
      if (!_this.state.isCollapsibleContainerOpen) {
        // Set state.isCollapsibleContainerOpen to true after the opening animation has completed
        // This allows overflow visible to be applied after the animation has completed
        setTimeout(_this.toggleCollapsibleContainer, _coreCollapsibleContainer.CollapsibleContainer.animateTime);
        return;
      }

      _this.toggleCollapsibleContainer();
    };

    return _this;
  }

  _createClass(FilterSection, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Styled.FilterSection, {
        id: "".concat(this.props.id, "-container"),
        isCollapsibleContainerOpen: this.state.isCollapsibleContainerOpen
      }, this.props.disableCollapse ? /*#__PURE__*/_react["default"].createElement(Styled.SimpleContainer, {
        renderInline: this.props.renderInline
      }, /*#__PURE__*/_react["default"].createElement(Styled.SimpleHeader, null, this.props.title, this.props.numberOfActiveFilters > 0 ? /*#__PURE__*/_react["default"].createElement(_corePill["default"], {
        text: "".concat(this.props.numberOfActiveFilters)
      }) : null), !this.props.renderInline && this.props.subText ? /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], null, this.props.subText) : null, /*#__PURE__*/_react["default"].createElement("div", null, this.props.children)) : /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainer, {
        isActive: true,
        onToggle: this.handleToggleCollapsibleContainer
      }, /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainerHeader, null, this.props.title, this.props.numberOfActiveFilters > 0 ? /*#__PURE__*/_react["default"].createElement(_corePill["default"], {
        text: "".concat(this.props.numberOfActiveFilters)
      }) : null), /*#__PURE__*/_react["default"].createElement(_coreCollapsibleContainer.CollapsibleContainerBody, null, this.props.subText ? /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], null, this.props.subText) : null, /*#__PURE__*/_react["default"].createElement(_coreSpacing["default"], {
        spacingLevel: {
          top: 2
        }
      }, this.props.children))));
    }
  }]);

  return FilterSection;
}(_react.PureComponent);

exports["default"] = FilterSection;
FilterSection.defaultProps = {
  renderInline: false
};
FilterSection.displayName = "FilterSection";
//# sourceMappingURL=FilterSection.js.map